import { render, staticRenderFns } from "./preAlipayAndRealNameDialog.vue?vue&type=template&id=0a740ac6&scoped=true"
import script from "./preAlipayAndRealNameDialog.vue?vue&type=script&lang=js"
export * from "./preAlipayAndRealNameDialog.vue?vue&type=script&lang=js"
import style0 from "./preAlipayAndRealNameDialog.vue?vue&type=style&index=0&id=0a740ac6&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a740ac6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/yto-crm-steward-h5/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0a740ac6')) {
      api.createRecord('0a740ac6', component.options)
    } else {
      api.reload('0a740ac6', component.options)
    }
    module.hot.accept("./preAlipayAndRealNameDialog.vue?vue&type=template&id=0a740ac6&scoped=true", function () {
      api.rerender('0a740ac6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/printingPage/sepecialOrderPrint/components/preAlipayAndRealNameDialog.vue"
export default component.exports